import _slicedToArray from "/tmp/builds/9f62e084-b84d-44d6-aa32-8caba7cc0d7f-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { classnames } from "./tools/classnames";
import { serializeStyles } from "@emotion/serialize";
import { insertStyles, getRegisteredStyles } from "@emotion/utils";
import { useGuaranteedMemo } from "./tools/useGuaranteedMemo";
import { matchCSSObject } from "./types";

var _ref = function () {
  function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles);
  }

  function createCssAndCx(params) {
    var cache = params.cache;

    var css = function css() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, cache.registered);
      insertStyles(cache, serialized, false);
      var className = "".concat(cache.key, "-").concat(serialized.name);

      scope: {
        var arg = args[0];

        if (!matchCSSObject(arg)) {
          break scope;
        }

        increaseSpecificityToTakePrecedenceOverMediaQueries.saveClassNameCSSObjectMapping(cache, className, arg);
      }

      return className;
    };

    var cx = function cx() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var className = classnames(args);
      var feat27FixedClassnames = increaseSpecificityToTakePrecedenceOverMediaQueries.fixClassName(cache, className, css);
      return merge(cache.registered, css, feat27FixedClassnames); //return merge(cache.registered, css, className);
    };

    return {
      css: css,
      cx: cx
    };
  }

  return {
    createCssAndCx: createCssAndCx
  };
}(),
    createCssAndCx = _ref.createCssAndCx;

export { createCssAndCx };
export function createUseCssAndCx(params) {
  var useCache = params.useCache;

  function useCssAndCx() {
    var cache = useCache();

    var _useGuaranteedMemo = useGuaranteedMemo(function () {
      return createCssAndCx({
        cache: cache
      });
    }, [cache]),
        css = _useGuaranteedMemo.css,
        cx = _useGuaranteedMemo.cx;

    return {
      css: css,
      cx: cx
    };
  }

  return {
    useCssAndCx: useCssAndCx
  };
} // https://github.com/garronej/tss-react/issues/27

var increaseSpecificityToTakePrecedenceOverMediaQueries = function () {
  var cssObjectMapByCache = new WeakMap();
  return {
    "saveClassNameCSSObjectMapping": function saveClassNameCSSObjectMapping(cache, className, cssObject) {
      var cssObjectMap = cssObjectMapByCache.get(cache);

      if (cssObjectMap === undefined) {
        cssObjectMap = new Map();
        cssObjectMapByCache.set(cache, cssObjectMap);
      }

      cssObjectMap.set(className, cssObject);
    },
    "fixClassName": function () {
      function fix(classNameCSSObjects) {
        var isThereAnyMediaQueriesInPreviousClasses = false;
        return classNameCSSObjects.map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              className = _ref3[0],
              cssObject = _ref3[1];

          if (cssObject === undefined) {
            return className;
          }

          var out;

          if (!isThereAnyMediaQueriesInPreviousClasses) {
            out = className;

            for (var key in cssObject) {
              if (key.startsWith("@media")) {
                isThereAnyMediaQueriesInPreviousClasses = true;
                break;
              }
            }
          } else {
            out = {
              "&&": cssObject
            };
          }

          return out;
        });
      }

      return function (cache, className, css) {
        var cssObjectMap = cssObjectMapByCache.get(cache);
        return classnames(fix(className.split(" ").map(function (className) {
          return [className, cssObjectMap === null || cssObjectMap === void 0 ? void 0 : cssObjectMap.get(className)];
        })).map(function (classNameOrCSSObject) {
          return typeof classNameOrCSSObject === "string" ? classNameOrCSSObject : css(classNameOrCSSObject);
        }));
      };
    }()
  };
}();